import type { SVGProps } from "react";
// generated from FileInfo.svg — do not edit manually
// prettier-ignore
export default function FileInfo(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 14 2 H 4 V 22 H 20 V 8 M 14 2 L 20 8 M 14 2 V 8 H 20 M 12 19 V 15 M 11.25 12 H 12.75" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
